import { initSettings } from './initSettings';
import { fetchReportDataFromRecords } from './fetchReportDataFromRecordIds.util';
import { processData } from './processData.util';
import { processJydacomSalaryData } from './processJydacomSalaryData.util';
import { isMepcoLitteraBusiness } from 'store/reports/utils/isMepcoLitteraBusiness.util';

const reports = require('./reports');

export const generateReportFromRecords = async (
  records,
  resources,
  assignments,
  users,
  generationParams,
  projects,
  selectedProject,
  recordAllowancesGroupedByRecordId,
  allowanceRecordsGroupedByParentRecordId,
  shadowRecordsMap,
  shadowProjectsMap,
  activeEmployerBusinessId
) => {
  const { selectedReportType } = generationParams;

  const settings = initSettings(generationParams);

  // Gate the Mepco littera (assignment number + name) breakdown to specific
  // businesses. When enabled, processData attaches per-assignment raw hours to
  // each project bucket so the Mepco CSV can be split per assignment.
  settings.isMepcoLitteraEnabled = isMepcoLitteraBusiness(
    selectedProject?.business_id
  );

  let reportData = await fetchReportDataFromRecords(
    selectedProject,
    records,
    resources,
    projects,
    assignments,
    users,
    recordAllowancesGroupedByRecordId,
    generationParams,
    allowanceRecordsGroupedByParentRecordId,
    shadowRecordsMap,
    activeEmployerBusinessId
  );

  let processedReportData;

  if (selectedReportType === 'jydacom_salary_report') {
    processedReportData = processJydacomSalaryData(
      reportData,
      settings,
      shadowProjectsMap,
      activeEmployerBusinessId
    );
  } else {
    processedReportData = processData(reportData, settings);
  }

  let tableRows;

  if (selectedReportType === 'balanco_salary_report') {
    // run with hour salary report logic
    tableRows = await reports['hour_salary_report'].createReport(
      processedReportData,
      settings,
      generationParams
    );
  } else {
    tableRows = await reports[selectedReportType].createReport(
      processedReportData,
      settings,
      generationParams
    );
  }

  let filename;

  if (selectedReportType === 'hour_listing_report') {
    const { documentName, documentFilename } = await reports[
      selectedReportType
    ].docName(settings);

    filename = documentFilename;
  }

  const resp = {
    documentData: {
      document: tableRows,
      filename,
    },
    processedData: {
      reportType: processedReportData.reportType,
      resources: processedReportData.resources,
      fromDate:
        selectedReportType !== 'hour_listing_report'
          ? processedReportData.fromDate
          : undefined,
      toDate:
        selectedReportType !== 'hour_listing_report'
          ? processedReportData.toDate
          : undefined,
      dataRows: tableRows.dataRows,
      headerRows: tableRows.headerRows,
      userTotalWorkAmountsByUserId: tableRows.userTotalWorkAmountsByUserId,
    },
  };

  return resp;
};
